export default __webpack_public_path__ + "media/zurb/img/icons/favicon/favicon-128-a8e0e13979fb76841f5fcd01b0add463.png";